// extracted by mini-css-extract-plugin
module.exports = {"embed_media_item":"__embed_media_item___1JOrG"};